import { useCreateNewReportFromTemplate } from 'api/mutations/CreateNewReportFromTemplate.mutation';
import { useQueryGetProgramGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList.query';
import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseCreateReportFromTemplateModalProvider = ReturnType<typeof useCreateReportFromTemplateModalProvider>;

export const useCreateReportFromTemplateModalProvider = () => {
    const getProgramGeneralHierrarchyList = useQueryGetProgramGeneralHierarchyList('ProgramLibraryUploadFiles');
    const getReportsTags = useQueryGetReportsTags();
    const instance = useCreateNewReportFromTemplate();

    return {
        api: {
            getProgramGeneralHierrarchyList,
            getReportsTags,
            createReportFromTemplate: {
                instance,
            },
        },
    };
};
